import { dimensionByTypesSelector } from '@src/store/common/dimensionList/selectors';
import { filterSelector } from '@src/store/common/selectors';
import { metricFilterSelector } from '@src/store/trends/base/selectors';
import {
  findDimensionDetailsInFilter,
  getFilterModeFromDimensionTypes,
} from '@src/utils/filter/getDimensionTypesFromFilter';
import { DIMENSION_TYPES_CONSTANTS } from '@src/utils/metrics';
import { useSelector } from 'react-redux';
import { ZERO } from './constant';

export const useEventGFWithSF = () => {
  const globalFilter = useSelector(filterSelector);
  const dimensionByTypes = useSelector(dimensionByTypesSelector);
  const { dimensionTypes } = findDimensionDetailsInFilter(globalFilter, dimensionByTypes);
  const filterMode = getFilterModeFromDimensionTypes(dimensionTypes);
  const metricFilter = useSelector(metricFilterSelector);

  // global filters have event level dimension && secondary filter is applied
  return (
    filterMode === DIMENSION_TYPES_CONSTANTS.eventTagKeyValueMetadata && metricFilter.length > ZERO
  );
};
